import { getAppConfig } from '../../app/core';



export class EoCPlaneConfig {
	public static readonly ost1_color = 0xF7A300;
	public static readonly ost2_color = 0xF7A300;
	public static readonly line1_color = 0xF7A300;
	public static readonly line2_color = 0xF7A300;
	public static readonly line3_color = 0xF7A300;
	public static readonly line4_color = 0xF7A300;
	public static readonly line5_color = 0xF7A300;
	public static CURSOR_ROTATE: string;

	public static init(): void {
		EoCPlaneConfig.CURSOR_ROTATE = `${getAppConfig().cdnUrl}/img/rotate_icon.cur`;
	}
}
